import Model from '../Model'
import moment from "moment";

export default class SiteInstruction extends Model {
    getFormAttributes() {
        return this;
    }

    static parseAttributes(attributes = {}) {
        return attributes
    }

    setAttributes(attributes) {
        super.setAttributes(attributes)
        this.formatted_date = moment(attributes.dateIssued).format('DD/MM/YYYY');
        let tokens = [this.formatted_date,]
        this.tokens = tokens.join('|').toLowerCase();
    }

    static async find(packageReference, id) {
        const data = await Http.get(route('api.v2.project-delivery.site-instruction', [packageReference, id]))
        return this.make(data);
    }

    static async list(packageReference = null) {
        const params = {}
        const data = await Http.get(route('api.v2.project-delivery.site-instruction.list', [packageReference]), {params})
        return this.make(data)
    }

    static async create(packageReference, id, attributes = {}) {
        const success = await Http.post(route('api.v2.project-delivery.site-instruction.create', [packageReference, id]), attributes);
        const data = await Http.get(route('api.v2.project-delivery.site-instruction', [packageReference, id]))
        return this.make(data)
    }

    async update(attributes = {}) {
        const url = route('api.v2.project-delivery.site-instruction.store', [this.packageReference, this.id])
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        const success = await Http.put(url, payload)
    }

    async delete() {
        await Http.delete(route('api.v2.project-delivery.site-instruction.delete', [this.packageReference, this.id]))
    }
}
